import { Tooltip, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../styles/colors';

export const SideMenuTooltip = ({ showTooltip, isMenuItemDisabled, label, children }) => {
  const { t } = useTranslation(['common']);
  return (
    <>
      {showTooltip && (
        <Tooltip
          title={`${t(isMenuItemDisabled ? 'common:sideMenu.noPermission' : label)}`}
          arrow
          placement='right'
          componentsProps={{
            arrow: {
              sx: {
                color: alpha(Colors.Blue, isMenuItemDisabled ? 0.7 : 1),
              },
            },
            tooltip: {
              sx: {
                zIndex: 5000,
                backgroundColor: alpha(Colors.Blue, isMenuItemDisabled ? 0.7 : 1),
                color: Colors.White,
                fontSize: '0.8rem',
                boxShadow: 3,
              },
            },
          }}
          aria-hidden
        >
          <span>{children}</span>
        </Tooltip>
      )}
      {!showTooltip && <>{children}</>}
    </>
  );
};
